export const telemetryCpu = (): {
	'telemetry:cpus': number;
} | null => {
	if (!navigator.hardwareConcurrency) {
		return null;
	}
	return {
		'telemetry:cpus': navigator.hardwareConcurrency,
	};
};
